import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./workingPartFilter.data.form";
import {
  InputDate,
  InputAutoComplete,
  InputSelect,
  InputText,
} from "@de-prado-dev/react-component-library";
import { PART_STATUS } from "../../../../constants/index";

const WorkingPartFilterForm = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    onClean,
    onFilterUser,
    onFilterArticle,
    onFilterBatch,
    onFilterLocation,
    onFilterTask,
    isTechnical,
    viveros,
  } = props;

  const renderListUser = (item) => {
    return `${item.name} ${item.surname}`;
  };

  const renderListArticle = (item) => {
    return `${item.name}`;
  };

  const renderListLocation = (item) => {
    return `${item.name} (${item.vivero.name})`;
  };

  const renderListTask = (item) => {
    return `${item.name}`;
  };

  const renderListBatch = (item) => {
    return `${item.code}`;
  };

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="workingPartFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.workingPart.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#workingPartFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    {!isTechnical && (
                      <div className="col-12 col-md-3">
                        <Field
                          id="userUuid"
                          className="form-control"
                          labelField={t("forms.workingPart.labels.user")}
                          name="userUuid"
                          component={InputAutoComplete}
                          fieldType="text"
                          onSearch={onFilterUser}
                          optionValue="uuid"
                          optionLabel="completeName"
                          textButtonReset={t("clear")}
                          renderItems={renderListUser}
                        />
                      </div>
                    )}

                    {!isTechnical && (
                      <div className="col-12 col-md-3">
                        <Field
                          id="articleUuid"
                          className="form-control"
                          labelField={t("forms.workingPart.labels.article")}
                          name="articleUuid"
                          component={InputAutoComplete}
                          fieldType="text"
                          onSearch={onFilterArticle}
                          optionValue="uuid"
                          optionLabel="name"
                          textButtonReset={t("clear")}
                          renderItems={renderListArticle}
                        />
                      </div>
                    )}

                    {!isTechnical && (
                      <div className="col-12 col-md-3">
                        <Field
                          id="batch"
                          className="form-control"
                          labelField={t("forms.workingPart.labels.batch")}
                          name="batch"
                          component={InputAutoComplete}
                          fieldType="text"
                          onSearch={onFilterBatch}
                          optionValue="uuid"
                          optionLabel="code"
                          textButtonReset={t("clear")}
                          renderItems={renderListBatch}
                        />
                      </div>
                    )}

                    {!isTechnical && (
                      <div className="col-12 col-md-3">
                        <Field
                          id="locationUuid"
                          className="form-control"
                          labelField={t("forms.workingPart.labels.location")}
                          name="locationUuid"
                          component={InputAutoComplete}
                          fieldType="text"
                          onSearch={onFilterLocation}
                          optionValue="uuid"
                          optionLabel="name"
                          textButtonReset={t("clear")}
                          renderItems={renderListLocation}
                        />
                      </div>
                    )}

                    {!isTechnical && (
                      <div className="col-12 col-md-3">
                        <Field
                          id="taskUuid"
                          className="form-control"
                          labelField={t("forms.workingPart.labels.task")}
                          name="taskUuid"
                          component={InputAutoComplete}
                          fieldType="text"
                          onSearch={onFilterTask}
                          optionValue="uuid"
                          optionLabel="name"
                          textButtonReset={t("clear")}
                          renderItems={renderListTask}
                        />
                      </div>
                    )}

                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="dateInit"
                        labelField={t("forms.workingPart.labels.dateInit")}
                        className="form-control"
                        name="dateInit"
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="dateEnd"
                        labelField={t("forms.workingPart.labels.dateEnd")}
                        className="form-control"
                        name="dateEnd"
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                        defaultHours={23}
                        defaultMinutes={59}
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="status"
                        name="status"
                        labelField={t("forms.workingPart.labels.status")}
                        // className="form-control"
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={PART_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="viveroUuid"
                        name="viveroUuid"
                        labelField={t("forms.users.labels.vivero")}
                        // className="form-control"
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="uuid"
                        options={viveros.map((item) => ({
                          ...item,
                          label: item.name,
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-danger"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkingPartFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const WorkingPartFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "WorkingPartFilterForm",
})(WorkingPartFilterForm);

export default WorkingPartFilterFormF;
